import { onLoad } from './utils/onLoad.js';
import { debounce } from './utils.js';
import * as Ajax from './utils/ajax.js';

const MIN_QUERY_LENGTH = 2;
const DEBOUNCE_MS = 250;
const SUGGEST_URL = '/api/v6/help/articles';

const hidePreview = (preview) => {
    preview.classList.add('d-none');
    preview.hidden = true;
};

const showPreview = (preview) => {
    preview.classList.remove('d-none');
    preview.hidden = false;
};

const renderResults = (root, results, query) => {
    const list = root.querySelector('.js-help-search-preview-list');
    const empty = root.querySelector('.js-help-search-preview-empty');
    const seeAll = root.querySelector('.js-help-search-see-all');
    const title = root.querySelector('.js-help-search-preview-title');

    list.innerHTML = '';

    if (results.length === 0) {
        title.classList.add('d-none');
        empty.classList.remove('d-none');
        seeAll.classList.add('d-none');
        showPreview(root);
        return;
    }

    title.classList.remove('d-none');
    empty.classList.add('d-none');
    seeAll.classList.remove('d-none');
    seeAll.href = `/ayuda/buscar?q=${encodeURIComponent(query)}`;

    results.forEach((article) => {
        const item = document.createElement('li');
        item.className = 'border-top border-grey-200';

        const link = document.createElement('a');
        link.href = article.url;
        link.className = 'd-block px-3 py-2 text-grey-800';
        link.setAttribute('role', 'option');

        const articleTitle = document.createElement('span');
        articleTitle.className = 'd-block text-primary-500';
        articleTitle.textContent = article.title;

        const path = document.createElement('span');
        path.className = 'd-block text-grey-600';
        path.textContent = `${article.category_title} · ${article.section_title}`;

        link.appendChild(articleTitle);
        link.appendChild(path);
        item.appendChild(link);
        list.appendChild(item);
    });

    showPreview(root);
};

const initHelpSearch = (form) => {
    const input = form.querySelector('.js-help-search-input');
    const preview = form.querySelector('.js-help-search-preview');
    if (!input || !preview) {
        return;
    }

    let requestId = 0;

    const runSearch = async () => {
        const query = input.value.trim();
        if (query.length < MIN_QUERY_LENGTH) {
            hidePreview(preview);
            return;
        }

        const currentRequestId = ++requestId;
        try {
            const data = await Ajax.get(SUGGEST_URL, { q: query });
            if (currentRequestId !== requestId) {
                return;
            }
            renderResults(preview, data.results || [], query);
        } catch (e) {
            if (currentRequestId === requestId) {
                hidePreview(preview);
            }
        }
    };

    const debouncedSearch = debounce(runSearch, DEBOUNCE_MS);

    input.addEventListener('input', debouncedSearch);
    input.addEventListener('focus', () => {
        if (input.value.trim().length >= MIN_QUERY_LENGTH) {
            runSearch();
        }
    });

    document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) {
            hidePreview(preview);
        }
    });

    input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            hidePreview(preview);
            input.blur();
        }
    });
};

onLoad(() => {
    document.querySelectorAll('.js-help-search-form').forEach(initHelpSearch);
});
